import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, makeObservable } from "mobx";
import { fromPromise } from "mobx-utils";
import SearchProviderResults from "../../Models/SearchProviders/SearchProviderResults";
function SearchProviderMixin(Base) {
  var _class;
  let SearchProviderMixin = (_class = class SearchProviderMixin extends Base {
    constructor() {
      super(...arguments);
      makeObservable(this);
    }
    search(searchText) {
      const result = new SearchProviderResults(this);
      if (!this.shouldRunSearch(searchText)) {
        result.resultsCompletePromise = fromPromise(Promise.resolve());
        result.message = {
          content: "translate#viewModels.searchMinCharacters",
          params: {
            count: this.minCharacters
          }
        };
        return result;
      }
      this.logEvent(searchText);
      result.resultsCompletePromise = fromPromise(this.doSearch(searchText, result));
      return result;
    }
    shouldRunSearch(searchText) {
      if (searchText === undefined || /^\s*$/.test(searchText) || this.minCharacters && searchText.length < this.minCharacters) {
        return false;
      }
      return true;
    }
    get hasSearchProviderMixin() {
      return true;
    }
  }, _applyDecoratedDescriptor(_class.prototype, "search", [action], Object.getOwnPropertyDescriptor(_class.prototype, "search"), _class.prototype), _class);
  return SearchProviderMixin;
}
(function (_SearchProviderMixin) {
  function isMixedInto(model) {
    return model && model.hasSearchProviderMixin;
  }
  _SearchProviderMixin.isMixedInto = isMixedInto;
})(SearchProviderMixin || (SearchProviderMixin = {}));
export default SearchProviderMixin;